import { API_URL } from '../circulusConfig';
import { encodeGetParams /* getHeaders */ } from '../common/util';
// import { POST, PATCH, PUT } from '../common/consts';

const managerInAPI = async (params) => {
  const res = await fetch(`${API_URL}private?${encodeGetParams(params)}`);
  const result = res.json();
  return result;
};

export { managerInAPI };
